import Badge from "@/components/Badge/Badge";
import ArrowIcon from "@/components/Icons/ArrowIcon";
import CardIcon from "@/components/Icons/CardIcon";
import TelegramStarsFilledIcon from "@/components/Icons/TelegramStarsFilledIcon";
import PageContent from "@/components/PageContent/PageContent";
import { useMarketingSectionsHeroTranslations } from "@/providers/I18n/hooks/useMarketingSectionsHeroTranslations";
import { Button } from "@itzme1on/uikit";

export default function HeroSection() {
	const t = useMarketingSectionsHeroTranslations();

	return (
		<PageContent className="py-16 min-h-screen">
			<div className="flex items-center gap-16 py-24 flex-1">
				<div className="w-full h-full flex flex-col gap-8">
					<div className="flex flex-col gap-5 items-start self-stretch">
						<Badge tone="soft">{t("badge")}</Badge>

						<h1 className="text-[52px] font-medium leading-15">
							{t.rich("title", {
								b: (children) => (
									<span className="text-[#5267e8]">{children}</span>
								),
							})}
						</h1>

						<p className="text-lg leading-7">{t("subtitle")}</p>
					</div>

					<div className="flex flex-row gap-3">
						<Button
							size="large"
							type="primary"
							suffixIcon={<ArrowIcon />}
						>
							{t("buttons.connect")}
						</Button>

						<Button size="large">{t("buttons.plans")}</Button>
					</div>

					<div className="text-front-secondary flex flex-row items-center text-sm gap-2">
						<CardIcon className="size-4.5" />

						<TelegramStarsFilledIcon className="size-4.5" />

						<span>{t("hint")}</span>
					</div>
				</div>

				<div className="w-120 h-104 shrink-0 rounded-3xl hero-card-gradient" />
			</div>
		</PageContent>
	);
}
